import { Field, TextIn, Toggle } from "@/components/forms/Field";
import ImageInput from "@/components/forms/ImageInput";
import { DEFAULT_THEME, DEFAULT_LABELS, FONTS } from "@/lib/forms";

const LABEL_KEYS = Object.keys(DEFAULT_LABELS);

function Color({ label, value, onChange, testid }) {
  return (
    <Field label={label}>
      <div className="flex gap-2">
        <input type="color" className="h-8 w-10 rounded border" value={value || "#000000"} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
        <TextIn value={value} onChange={onChange} testid={`${testid}-text`} />
      </div>
    </Field>
  );
}

export default function DesignPanel({ form, setForm }) {
  const s = form.settings || {};
  const t = { ...DEFAULT_THEME, ...(s.theme || {}) };
  const L = { ...DEFAULT_LABELS, ...(s.labels || {}) };
  const setS = (p) => setForm({ ...form, settings: { ...s, ...p } });
  const setT = (p) => setS({ theme: { ...t, ...p } });
  const sel = "w-full px-2.5 py-1.5 rounded border text-sm";
  return (
    <div className="space-y-4" data-testid="design-panel">
      <section className="panel p-4 space-y-3">
        <h3 className="text-sm font-medium">Brand</h3>
        <Field label="Logo" hint="Defaults to the T&T logo. Upload PNG/WEBP with a transparent background."><ImageInput value={t.logo_url} onChange={(v) => setT({ logo_url: v })} testid="theme-logo" /></Field>
        <div className="grid grid-cols-2 gap-2">
          <Field label="Logo position">
            <select className={sel} value={t.logo_position} onChange={(e) => setT({ logo_position: e.target.value })} data-testid="theme-logo-pos"><option value="left">Top left</option><option value="center">Top centre</option></select>
          </Field>
          <Field label="Logo height (px)"><TextIn type="number" value={t.logo_height} onChange={(v) => setT({ logo_height: v })} testid="theme-logo-height" /></Field>
        </div>
      </section>
      <section className="panel p-4 space-y-3">
        <h3 className="text-sm font-medium">Colours & type</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <Color label="Background" value={t.bg_color} onChange={(v) => setT({ bg_color: v })} testid="theme-bg" />
          <Color label="Text" value={t.text_color} onChange={(v) => setT({ text_color: v })} testid="theme-text" />
          <Color label="Buttons & answers" value={s.accent_color || "#ffffff"} onChange={(v) => setS({ accent_color: v })} testid="accent-color" />
          <Field label="Font">
            <select className={sel} value={t.font} onChange={(e) => setT({ font: e.target.value })} data-testid="theme-font">{FONTS.map((f) => <option key={f}>{f}</option>)}</select>
          </Field>
          <Field label="Button shape">
            <select className={sel} value={t.button_radius} onChange={(e) => setT({ button_radius: e.target.value })} data-testid="theme-radius">
              <option value="none">Sharp</option><option value="md">Rounded</option><option value="pill">Pill</option>
            </select>
          </Field>
          <Field label="Alignment">
            <select className={sel} value={t.align} onChange={(e) => setT({ align: e.target.value })} data-testid="theme-align"><option value="left">Left</option><option value="center">Centre</option></select>
          </Field>
        </div>
        <Field label="Background image"><ImageInput value={t.bg_image_url} onChange={(v) => setT({ bg_image_url: v })} testid="theme-bg-image" /></Field>
        {t.bg_image_url && (
          <Field label={`Overlay darkness · ${Math.round(Number(t.bg_overlay) * 100)}%`}>
            <input type="range" min="0" max="0.95" step="0.05" value={t.bg_overlay} onChange={(e) => setT({ bg_overlay: Number(e.target.value) })} className="w-full" data-testid="theme-overlay" />
          </Field>
        )}
        <Toggle checked={s.show_progress !== false} onChange={(v) => setS({ show_progress: v })} label="Show progress bar" testid="show-progress" />
      </section>
      <section className="panel p-4 space-y-2" data-testid="labels-panel">
        <h3 className="text-sm font-medium">Button & message text</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {LABEL_KEYS.map((k) => (
            <Field key={k} label={k.replace(/_/g, " ")}>
              <TextIn value={L[k]} onChange={(v) => setS({ labels: { ...L, [k]: v } })} testid={`label-${k}`} />
            </Field>
          ))}
        </div>
      </section>
    </div>
  );
}
